module.exports = __webpack_public_path__ + "img/like.b0a00687.svg";